<template>
    <div>

        <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-button type="primary" icon="el-icon-search" @click="callFunc({'func':'toggleFilter'})">筛选</el-button>
            <el-form :inline="true" @submit.native.prevent style="float: right;">
                <!-- 这个就是当前页面内，所有的btn列表 -->
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button :type="item.func&&(item.func.toLowerCase().indexOf('handledel')!= -1 ||item.func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.isHide && item.func !== 'getListData'" @click="callFunc(item)">{{item.name}}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-setting" @click="openColumnConfig">列配置</el-button>
                </el-form-item>
            </el-form>
        </el-col>

          <!-- 列配置弹窗 -->
        <el-dialog title="列配置" :visible.sync="columnConfigVisible" width="30%">
            <el-checkbox-group v-model="localVisibleColumns">
                <el-checkbox v-for="col in allColumns" :key="col.prop" :label="col.prop">{{ col.label }}</el-checkbox>
            </el-checkbox-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="columnConfigVisible = false">取消</el-button>
                <el-button type="primary" @click="saveColumnConfig">提交</el-button>
            </div>
        </el-dialog>
</div>  
</template>


<script>
export default {
	name: "Searchbar",
	data() {
		return {
			searchVal: "", //双向绑定搜索内容
			show: true,
            columnConfigVisible: false, // 列配置弹窗是否显示
            localVisibleColumns: [...this.visibleColumns] 
            
		};
	},
	props: ["buttonList","isShow","visibleColumns","allColumns"], //接受父组件传值
    watch: {
        // 监听父组件传来的 prop 变化，同步更新本地副本
        visibleColumns(newVal) {
            this.localVisibleColumns = newVal;
        }
    },
	methods: {
		callFunc(item) {
			item.search = this.searchVal;
			this.$emit("callFunction", item); //将值传给父组件
		},
        // 打开列配置弹窗
        openColumnConfig() {
            this.columnConfigVisible = true;
        },
        // 保存列配置（动态控制表格列显示）
        saveColumnConfig() {
            // console.log('选中列:', this.localVisibleColumns);
            // 保存在redis中
            this.$emit('setVisibleColumns', this.localVisibleColumns);
            this.columnConfigVisible = false;
        },
	},
	mounted(){
		if(this._props.isShow == false){
			this.show = this._props.isShow
		}else{
			this.show = true
		}

	}
};
</script>
